import {
  Create,
  Edit,
  SelectInput,
  SimpleForm,
  TextInput,
  maxLength,
  required,
  useGetIdentity,
  useRecordContext,
} from "react-admin";

import { Grid } from "@mui/material";
import react from "react";
import styled from "styled-components";
import { useFetchProfitCentersQuery } from "src/@generated/hooks";

export const DefaultLocation = {
  latitude: 0,
  longitude: 0,
};

const isoCountryCodes = [
  "US",
  "CZ",
  "DE",
  "FR",
  "GB",
  "IT",
  "ES",
  "PL",
  "NL",
  "SE",
  "CH",
  "AT",
  "BE",
  "DK",
  "NO",
  "FI",
  "HU",
  "SK",
  "PT",
  "IE",
  "GR",
  "RO",
  "BG",
  "HR",
  "SI",
  "LT",
  "LV",
  "EE",
  "LU",
  "MT",
  "CY",
];

const validateCountryCode = (value: string) => {
  return isoCountryCodes.includes(value) ? undefined : "Neplatný název země";
};

const Form = () => {
  const record = useRecordContext();
  const { identity } = useGetIdentity();
  const { data: profitCenters } =
    useFetchProfitCentersQuery();

  const phoneValidation = value => {
    if (!value) return '';

    // odstraní vše kromě číslic
    const digits = value.replace(/\D/g, '');

    if (digits.length < 9 || digits.length > 15) {
      return 'Telefon musí mít 9–15 číslic';
    }

    return undefined;
  };

  return (
    <SimpleForm
      defaultValues={{
        note: "",
      }}
    >
      <Grid container spacing={8}>
        <Grid item md={6}>
          <Row>
            <ColTextInput source="id" readOnly fullWidth />
            <ColTextInput source="name" validate={[required(), maxLength(40)]} fullWidth />
            {identity?.selectedCompany?.carloPartnerId ? (
              <ColTextInput
                source="customerNumber"
                validate={record?.id ? [] : [required()]}
                readOnly={!!record?.id}
                fullWidth
              />
            ) : null}
          </Row>
          <Row>
            <ColTextInput source="street" validate={[required()]} />
            <ColTextInput source="houseNumber" /*validate={[required()]}*/ />
            <ColTextInput source="town" validate={[required()]} />
          </Row>
          <Row>
            <ColTextInput source="zip" validate={[required()]} />
            <ColSelectInput
              source="country"
              choices={isoCountryCodes.map((code) => ({
                id: code,
                name: code,
              }))}
              style={{ height: 43 }}
              validate={[required(), validateCountryCode]}
              inputProps={{ maxLength: 2 }}
            />
          </Row>
          {identity?.selectedCompany?.ingresId ? (
            <Row>
              {/* <ColTextInput source="profitCenter" validate={[required()]} /> */}
              <ColSelectInput
                source="profitCenter"
                choices={(profitCenters?.fetchProfitCenters || [])?.map(
                  (profitCenter) => ({
                    id: profitCenter.code,
                    name: `${profitCenter.name} (${profitCenter.code})`,
                  })
                )}
                style={{ height: 43 }}
                validate={[required(), maxLength(20)]}
                inputProps={{ maxLength: 2 }}
              />
            </Row>
          ) : null}
        </Grid>
        <Grid item md={6}>
          <Row>
            <ColTextInput source="firstName" />
            <ColTextInput source="lastName" />
          </Row>
          <TextInput source="phone" validate={[phoneValidation]} fullWidth />
          <TextInput source="note" fullWidth />
          <TextInput source="email" fullWidth />
          {/* <FormDataConsumer>
            {() => {
              const { setValue, watch } = useFormContext();
              // const refSearchInputMap = useRef();
              const [searchBoxRef, setSearchBoxRef] =
                useState<google.maps.places.SearchBox>();
              const geocoder = new google.maps.Geocoder();

              const geoCoord = watch("geoCoord");
              const street = watch("street");

              // useEffect(() => {
              //   console.dir(refSearchInputMap.current);
              //   // if (refSearchInputMap.current?.value) {
              //   //   refSearchInputMap.current = street;
              //   // }
              // }, [street]);

              const latitude = geoCoord?.latitude || DefaultLocation.latitude;
              const longitude = geoCoord?.longitude || DefaultLocation.longitude;

              const handleSearchboxChanged = () => {
                const places = searchBoxRef.getPlaces();
                const firstPlace = places[0];

                const lat = firstPlace.geometry.location.lat();
                const lng = firstPlace.geometry.location.lng();

                setValue("geoCoord", { latitude: lat, longitude: lng });
              };
              return (
                <>
                  <GoogleMap
                    mapContainerStyle={{
                      width: "100%",
                      height: 400,
                    }}
                    center={{
                      lat: latitude,
                      lng: longitude,
                    }}
                    zoom={16}
                  >
                    <GoogleMapsInputWrapper>
                      <StandaloneSearchBox
                        onLoad={setSearchBoxRef}
                        onPlacesChanged={handleSearchboxChanged}
                      >
                        <MuiTextField
                          variant="outlined"
                          onKeyUp={(event) => {
                            if (event.key === "Enter") {
                              event.stopPropagation();
                            }
                          }}
                          placeholder="Search address"
                          style={{ background: "white" }}
                        />
                      </StandaloneSearchBox>
                    </GoogleMapsInputWrapper>
                    <Marker
                      draggable
                      onDragEnd={(e) => {
                        geocoder
                          .geocode({ location: e.latLng })
                          .then((response) => {
                            if (response.results[0]) {
                              setValue("geoCoord", {
                                latitude: e.latLng.lat(),
                                longitude: e.latLng.lng(),
                              });
                            }
                          });
                      }}
                      position={{
                        lat: latitude,
                        lng: longitude,
                      }}
                    />
                  </GoogleMap>
                  {latitude}, {longitude}
                </>
              );
            }}
          </FormDataConsumer> */}
        </Grid>
      </Grid>
    </SimpleForm>
  );
};

export const LocationCreate = () => (
  <Create redirect="list">
    <Form />
  </Create>
);

export const LocationEdit = () => (
  <Edit mutationMode="pessimistic" redirect="list">
    <Form />
  </Edit>
);

export const ColTextInput = styled(TextInput)`
  flex: 1;
  width: 50%;
`;

export const ColSelectInput = styled(SelectInput as any)`
  flex: 1;
  width: 50%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  ${ColTextInput} ~ ${ColTextInput}, ${ColTextInput} ~ ${ColSelectInput} {
    margin-left: 8px;
  }
`;

export const GoogleMapsInputWrapper = styled.div`
  position: absolute;
  top: 65px;
  left: 10px;
  z-index: 100;
`;
